import React from 'react';
import PropTypes from 'prop-types';

export default class Relative extends React.Component {
  static propTypes = {
    component: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    className: PropTypes.string,
  };

  static defaultProps = {
    component: 'div',
    className: undefined,
  };

  render() {
    const { component: Component, className, ...props } = this.props;

    return <Component className={className} {...props} />;
  }
}
